import { RequestBasePageId } from "@myapp/modules/fwcore/models/messages/request-base";
import { ResponseBasePage } from "@myapp/modules/fwcore/models/messages/response-base";
import { LogSystem } from "../log-system";

export class RequestLogSystem extends RequestBasePageId {

  fromDate?: Date;
  toDate?: Date;

  licenseId?: string | null;
  moduleId?: string | null;

  categoryIds?: string[] | null;
  severities?: string[] | null;

  loggedBy?: string | null;
  source?: string | null;

}

export class ResponseLogSystem extends ResponseBasePage<LogSystem> {

}

